import axios from 'axios';
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import { setAuthTokenAndSaveData } from '../../auth/auth';
import { getImageUrl } from '../../auth/imagehosting';
import { AuthProvider } from '../../Context/AuthContext';
import ScrollToTop from '../../Shared/ScrollToTop/ScrollToTop';
import SmallSpinner from '../../Shared/Spinner/SmallSpinner';

const Admission = () => {
    const { createUser, updateUserProfile } = useContext(AuthProvider)
    const navigate = useNavigate()

    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(" ")

    const onSubmit = data => {
        console.log(data)
        const email = data.email
        const password = data.password
        const image = data.image[0]
        const name = `${data.firstname + " " + data.lastname}`
        const phone = data.phone 
        const country = data.country 
        const gender = data.gender 
        const education = data.education 
        const age = data.age 
        const permenentAddress = {
            district: data.district ,
            subDistrict : data.subdistrict,
            zipcode: data.zipcode 
        }
        const presentAddress = data.presentAddress
        const message = data.message 
        const captcha = data.check  

        setLoading(true)
        getImageUrl(image)
            .then(imageURL => {
                console.log(imageURL)

                // create user 
                createUser(email, password)
                    .then(result => {
                        const user = result.user
                        console.log(user)
                        updateUserProfile(name, imageURL )
                        const currentUserData = {
                            image: imageURL,
                            email: user?.email ,
                            name : name, 
                            education:  education,
                            phone : phone ,
                            age: age ,
                            country: country ,
                            gender: gender ,
                            permenentAddress: permenentAddress,
                            presentAddress: presentAddress,
                            message: message, 
                            captcha: captcha
                        }
                        axios.put(`${process.env.REACT_APP_API_URL}/users/${user?.email}`, currentUserData)
                        // setAuthTokenAndSaveData(currentUserData)
                        .then(res => {
                            console.log(res.data)
                            if(res.data?.result?.acknowledged === true){
                                toast.success("User Created Successfully")
                                setLoading(false)
                                navigate('/')
                            }
                        })
                        .catch(err => {
                            console.log(err)
                            setLoading(false)
                            toast.error("Please Fill All the Field")
                        })

                    })
                    .catch(err => {
                        console.log(err)
                        setError(err.message)
                        setLoading(false)
                        toast.error("User Already Exists")
                    })


            })

    };
    return (
        <div className='max-w-6xl mx-auto px-5 xl:px-0 py-11 md:py-16'>
            <ScrollToTop />
            <div className='flex items-start flex-col lg:flex-row gap-7'>
                <div className='px-5 md:px-0 lg:w-96 w-full'>
                    <h3 className='text-4xl font-semibold  text-gray-600 pb-7'>Admission</h3>
                    <p className="text-md font-semibold text-gray-600">Please fill up all the section casefully.</p>
                    <p className="text-md font-semibold text-gray-600 pb-5">If you have any query feel free to contact with us.</p>
                    <p className="text-gray-500 text-sm">In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>

                    <div className='py-5 mb-7'>
                        <h4 className='text-sm'><i class="fa-solid fa-phone pr-2 text-gray-500"></i> +8801911855010</h4>
                        <h4 className='text-sm'><i class="fa-solid fa-phone pr-2 text-gray-500"></i> +8801911855010</h4>
                        <p className='text-blue-500'><i class="fa-solid fa-envelope pr-2 text-gray-500"></i>tauhidkhan@gmail.com</p>
                    </div>
                    <Link className='px-5 py-2 border-2 border-blue-500 uppercase  text-blue-500 hover:text-black hover:border-black'>Browse Course</Link>
                </div>

                <div className='flex-1'>
                    <div className='bg-gray-100 px-5 sm:px-7 py-7 rounded-xl'>
                        <form onSubmit={handleSubmit(onSubmit)} action="">
                            <h3 className='text-3xl font-semibold pb-5 text-gray-600'>Your Personal Info</h3>
                            <p className='text-red-500 py-3 text-center'>{error?.message}</p>

                            <label for="dropzone-file" class="flex items-center px-3 py-3 mx-auto text-center bg-white border-2 border-dashed rounded-lg cursor-pointer dark:border-gray-600 dark:bg-gray-900 mb-6">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-300 dark:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                </svg>

                                <h2 class="mx-3 text-gray-400">Profile Photo</h2>

                                <input id="dropzone-file" type="file" class="hidden" {...register("image")} required />
                            </label>
                            <div class=" w-full grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div class="relative flex items-center w-full">
                                    <span class="absolute">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mx-3 text-gray-300 dark:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                        </svg>
                                    </span>

                                    <input type="text" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-11 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="First Name" {...register("firstname")}  required />
                                </div>

                                <div class="relative flex items-center w-full">
                                    <span class="absolute">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mx-3 text-gray-300 dark:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                        </svg>
                                    </span>

                                    <input type="text" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-11 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Last Name" {...register("lastname")} required/>
                                </div>


                                <div class="relative flex items-center w-full">
                                    <span class="absolute">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mx-3 text-gray-300 dark:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                        </svg>
                                    </span>

                                    <input type="email" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-11 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Email address" {...register("email")}  required/>
                                </div>

                                <div class="relative flex items-center w-full">
                                    <i class="fa-solid fa-phone absolute text-gray-300 mx-3 text-lg"></i>

                                    <input type="text" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-11 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Enter Phone Number" {...register("phone")} />
                                </div>

                                <div class="relative flex items-center w-full">
                                    <i class="fa-solid fa-earth-americas  absolute text-gray-300 mx-3 text-lg"></i>

                                    <select type="email" class="block w-full py-3 text-gray-400 bg-white border rounded-lg px-11 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Select Your Country" {...register("country")}>
                                        <option className='pr-5'>Select Your Country</option>
                                        <option value='Bangladesh'>Bangladesh</option>
                                        <option value='Saudiarab'>Saudiarab</option>
                                        <option value='London'>London</option>
                                        <option value='Katar'>Katar</option>
                                    </select>
                                </div>

                                <div class="relative flex items-center w-full">
                                    <i class="fa-solid fa-user absolute text-gray-300 mx-3 text-lg"></i>

                                    <select type="email" class="block w-full py-3 text-gray-400 bg-white border rounded-lg px-11 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Select Your Country" {...register("gender")}>
                                        <option className='pr-5'>Select Your Gender</option>
                                        <option value='Male'>Male</option>
                                        <option value="Fimale">Fimale</option>
                                        <option value='Others'>Others</option>
                                    </select>
                                </div>

                                <div class="relative flex items-center w-full">
                                    <i class="fa-solid fa-user absolute text-gray-300 mx-3 text-lg"></i>

                                    <select type="email" class="block w-full py-3 text-gray-400 bg-white border rounded-lg px-11 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Select Your Education" {...register("education")}>
                                        <option className='pr-5' >Select Your Education Level</option>
                                        <option value='Less thsn high school'>Less thsn high school</option>
                                        <option value='Higher Secondary School or equivalent'>Higher Secondary School or equivalent</option>
                                        <option value='Some College no degree'>Some College no degree</option>
                                        <option value='Bachelors degree'>Bachelors degree</option>
                                        <option value='Doctoral or Professional degree'>Doctoral or Professional degree</option>
                                    </select>
                                </div>

                                <div class="relative flex items-center w-full">
                                    <i class="fa-brands fa-pagelines absolute text-gray-300 mx-3 text-lg"></i>

                                    <input type="text" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-11 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Age" {...register("age")} />
                                </div>

                                {/* <label for="dropzone-file" class="flex items-center px-3 py-3 mx-auto mt-6 text-center bg-white border-2 border-dashed rounded-lg cursor-pointer dark:border-gray-600 dark:bg-gray-900">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-300 dark:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                    </svg>

                                    <h2 class="mx-3 text-gray-400">Profile Photo</h2>

                                    <input id="dropzone-file" type="file" class="hidden" />
                                </label> */}


                            </div>

                            <div className='mt-9'>
                                <h3 className='text-2xl font-medium  text-gray-500 '>Your Address Info</h3>
                                <p className='text-sm text-gray-500'>Write your Permanent Address here.</p>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5">
                                    <div class="relative flex items-center w-full">
                                        <i class="fa-solid fa-building-circle-arrow-right absolute text-gray-300 mx-3 text-lg"></i>

                                        <input type="text" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-11 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Home District" {...register("district")} />
                                    </div>
                                    <div class="relative flex items-center w-full">
                                        <i class="fa-solid fa-house-circle-check absolute text-gray-300 mx-3 text-lg"></i>

                                        <input type="text" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-11 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Sub District" {...register("subdistrict")} />
                                    </div>
                                    <div class="relative flex items-center w-full">
                                        <i class="fa-solid fa-code-branch absolute text-gray-300 mx-3 text-lg"></i>

                                        <input type="text" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-11 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Zip Code" {...register("zipcode")} />
                                    </div>
                                </div>
                                <div class="relative flex items-center w-full mt-6">
                                    <i class="fa-solid fa-house absolute text-gray-300 mx-3 text-lg"></i>

                                    <input type="text" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-11 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Present Address Details" {...register("presentaddress")} />
                                </div>
                            </div>

                            <div className="flex flex-col md:flex-row mt-6 items-center gap-6 w-full">
                                <div class="relative flex items-center w-full ">
                                    <span class="absolute">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mx-3 text-gray-300 dark:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                        </svg>
                                    </span>

                                    <input type="password" class="block w-full px-10 py-3 text-gray-700 bg-white border rounded-lg dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Password" {...register("password")} required/>
                                </div>

                                <div class="relative flex items-center w-full">
                                    <span class="absolute">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mx-3 text-gray-300 dark:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                        </svg>
                                    </span>

                                    <input type="password" class="block w-full px-10 py-3 text-gray-700 bg-white border rounded-lg dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40" placeholder="Confirm Password" {...register("passwordconfirm")} required/>
                                </div>
                            </div>

                            <textarea class="block w-full h-44 mt-6 px-5 py-3 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-md md:h-56 dark:placeholder-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40 " placeholder="About your self more than 350" {...register("message")} />

                            <div className="flex itmes-center justify-between flex-col md:flex-row mt-6 gap-5 sm:gap-0">
                                <input type="text" class="block w-full py-3 text-gray-700 bg-white border rounded-lg px-11 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:ring-blue-300 focus:outline-none focus:ring focus:ring-opacity-40 max-w-sm" placeholder="Are you human ? 4 + 1 = ?" {...register("check")} />
                                <button type='submit' class="px-9 py-2 md:py-1.5 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-500 rounded-lg hover:bg-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50">
                                    {
                                        loading ?  
                                        <SmallSpinner/>
                                        :
                                        'Submit'
                                    }
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Admission;